// extracted by mini-css-extract-plugin
export default {"noParams":"ActionUi_noParams__9UcED"};